import React, {Component} from 'react';
import '../../App.css'

export default class Footer extends Component {

    render() {
        return(
            <footer className="App-footer">
                <div>
                    <h6>
                    Ce travail est sous licence «Creative Commons Attribution-NonCommercial-ShareAlike 4.0 International License. BY-NC-SA 4.0 CC License»
                    </h6>
                </div>
            </footer>
        )
    }

}